import { render, staticRenderFns } from "./TagsInput.vue?vue&type=template&id=ea12891e&scoped=true"
import script from "./TagsInput.vue?vue&type=script&lang=js"
export * from "./TagsInput.vue?vue&type=script&lang=js"
import style0 from "./TagsInput.vue?vue&type=style&index=0&id=ea12891e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea12891e",
  null
  
)

export default component.exports